/* ============================================================
   MAISON CLAIR — Animaciones y utilidades
   1) Fade-up: secciones marcadas con .mc-fade-up reciben
      .mc-inview al entrar en pantalla.
   2) Video sin controles: en secciones con .mc-no-video-controls
      se remueve el atributo controls.
   3) Desactivar por dispositivo: las secciones con .mc-off-mobile
      o .mc-off-desktop se eliminan del documento según el ancho
      de pantalla (no cargan medios ni reproducen video).
   ============================================================ */
(function () {
  document.documentElement.classList.add('mc-js');

  var MOBILE_MAX = 749; // mismo punto de corte que Pitch

  function isMobile() {
    return window.innerWidth <= MOBILE_MAX;
  }

  // Dentro del editor de temas no eliminamos nada: si la sección
  // desaparece del documento, no se puede seleccionar ni editar.
  function inThemeEditor() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  /* ---------- 1. FADE-UP ---------- */
  function initFadeUp() {
    var sections = [];
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (s.querySelector('.mc-fade-up')) sections.push(s);
    });

    if (!sections.length) return;

    if (!('IntersectionObserver' in window)) {
      sections.forEach(function (s) { s.classList.add('mc-inview'); });
      return;
    }

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('mc-inview');
            io.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15 }
    );

    sections.forEach(function (s) { io.observe(s); });
  }

  /* ---------- 2. VIDEO SIN CONTROLES ---------- */
  function stripControls() {
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (!s.querySelector('.mc-no-video-controls')) return;
      s.querySelectorAll('video[controls]').forEach(function (v) {
        v.removeAttribute('controls');
      });
    });
  }

  /* ---------- 3. DESACTIVAR POR DISPOSITIVO ---------- */
  function removeForDevice() {
    if (inThemeEditor()) return;

    var marker = isMobile() ? '.mc-off-mobile' : '.mc-off-desktop';

    document.querySelectorAll('.shopify-section').forEach(function (s) {
      if (!s.querySelector(marker)) return;

      // Detener cualquier video antes de retirar la sección
      s.querySelectorAll('video').forEach(function (v) {
        try {
          v.pause();
          v.removeAttribute('src');
          v.load();
        } catch (e) {}
      });

      s.remove();
    });
  }

  function init() {
    removeForDevice(); // primero: quitar lo que no va en este dispositivo
    initFadeUp();
    stripControls();

    // Pitch carga contenido en diferido; vigilamos el DOM para
    // limpiar lo que aparezca después.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          if (mutations[i].addedNodes.length) {
            stripControls();
            removeForDevice();
            break;
          }
        }
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();